import { AppUtils } from '../../utils/index';

export class CooperationDataModel {

	private processid: string;
	get Processid(): string {
		return this.processid;
	}
	set Processid(value: string) {
		this.processid = value;
	}

	private formid: string;
	public get Formid(): string {
		return this.formid;
	}
	public set Formid(value: string) {
		this.formid = value;
	}

	private siteurl: string;
	get Siteurl(): string {
		return this.siteurl;
	}
	set Siteurl(value: string) {
		this.siteurl = value;
	}

	private subject: string;
	get Subject(): string {
		return this.subject;
	}
	set Subject(value: string) {
		this.subject = value;
	}

	private targetemail: string;
	get Targetemail(): string {
		return this.targetemail;
	}
	set Targetemail(value: string) {
		this.targetemail = value;
	}

	private dynamics: { [key: string]: any };
	get Dynamics(): { [key: string]: any } {
		return this.dynamics;
	}
	set Dynamics(value: { [key: string]: any }) {
		this.dynamics = value;
	}

	public static createFromObject(dataObject: { [key: string]: any }): CooperationDataModel {
		return AppUtils.Helper.createFromMap(dataObject, CooperationDataModel);
	}
}